export default {
  // Tooltip and specific messages
  editRequirementsTooltip: 'Edit hours and credits requirements',
  viewRequirementsTooltip: 'View hours and credits requirements',
  editRequirementsModalTitle: 'EDIT HOURS AND CREDITS REQUIREMENTS',
  viewRequirementsModalTitle: 'VIEW HOURS AND CREDITS REQUIREMENTS',

  // LimitStudyPlan
  total: 'TOTAL',
  maximumSuggestedIn: 'Maximum suggested in {entity}',
  hours: 'Hours',
  credits: 'Credits',
  level: 'LEVEL',
  levelName: '{level} LEVEL',
  maximumSuggestedCredits: 'Maximum suggested Credits',
}